module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_8017.499e78c1.png";